<template>
	<span class="ov-badge" :class="`ov-badge--${variant}`" @click="$emit('click', $event)">
		<slot />
	</span>
</template>

<script>
export default {
	name: "OvBadge",
	props: {
		variant: { type: String, default: "default" },
	},
	emits: ["click"],
};
</script>

<style lang="scss" scoped>
.ov-badge {
	display: inline-block;
	padding: 3px 8px;
	font-size: 10px;
	font-weight: 600;
	border-radius: 999px;
	letter-spacing: 0.02em;

	&--default,
	&--dark {
		background: #374151;
		color: #fff;
	}

	&--primary {
		background: var(--ds-color-primary);
		color: #fff;
	}

	&--secondary {
		background: #e5e7eb;
		color: #374151;
	}

	&--info {
		background: #dbeafe;
		color: #1e40af;
	}

	&--success {
		background: #dcfce7;
		color: #166534;
	}

	&--warning {
		background: #fef3c7;
		color: #92400e;
	}

	&--danger {
		background: #fee2e2;
		color: #991b1b;
	}

	&--light {
		background: #f3f4f6;
		color: #4b5563;
	}
}
</style>
